module.exports = __webpack_public_path__ + "static/media/N021-Green-110mm-Bow-Velvet-Mule-Sandals-Lyst_thumb.ade071dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/N021-Green-110mm-Bow-Velvet-Mule-Sandals-Lyst_thumb.png
// module id = 282
// module chunks = 0